import React, { useState, useEffect } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import LastPageIcon from '@mui/icons-material/LastPage'

function PaginationControl ({ page, totalItems, itemsPerPage, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(page)
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  useEffect(() => setCurrentPage(page), [page])

  const handleChange = (newPage) => {
    setCurrentPage(newPage)
    onPageChange(newPage)
  }

  const start = (currentPage - 1) * itemsPerPage + 1
  const end = Math.min(currentPage * itemsPerPage, totalItems)

  return (
    <Box>
      <Box alignItems='center'>
        <IconButton onClick={() => handleChange(1)} disabled={currentPage === 1}>
          <FirstPageIcon />
        </IconButton>
        <IconButton onClick={() => handleChange(currentPage - 1)} disabled={currentPage === 1}>
          <NavigateBeforeIcon />
        </IconButton>
        <IconButton onClick={() => handleChange(currentPage + 1)} disabled={currentPage === totalPages}>
          <NavigateNextIcon />
        </IconButton>
        <IconButton onClick={() => handleChange(totalPages)} disabled={currentPage === totalPages}>
          <LastPageIcon />
        </IconButton>
      </Box>
      <Typography variant='body2' sx={{ mx: 1 }}>
        {`${start}–${end} of ${totalItems}`}
      </Typography>
    </Box>

  )
}

export default PaginationControl
